import React from "react";
import { Route } from "react-router-dom";
import { PluginRoute } from "../shared/services/pluginService";

// Plugin routes mount inside the viewer layout (Sidenav chrome); nested children require the
// parent element to render an <Outlet />...
export function renderPluginRoute(route: PluginRoute, key: string): React.ReactElement {
    return (
        route.index ?
            <Route key={key} index element={route.element} /> :
            <Route key={key} path={route.path} element={route.element}>
                {route.children?.map((child, index) => renderPluginRoute(child, `${key}.${index}`))}
            </Route>
    );
}
